import { LoadableLazy } from '@confluence/loadable';

export const ResolvedInlineCommentsDialogLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ResolvedInlineCommentsDialog" */ '../src/ResolvedInlineCommentsDialog.tsx'
			)
		).ResolvedInlineCommentsDialog,
});
